export default "__VITE_ASSET__C2gr$S5H__"